const detailsDialog4i = function(){
	const common = new CartCommon();
	const messages = common.Messages;
	const detailsDialog = new Dialog4i();
	const loadingContent = '<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading item details dialog, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
	let prodName, dialog, dialogHead, dialogContent;
	
	const init = () =>{
		detailsDialog.Init({
			triggerElements: [].slice.call(document.querySelectorAll('.cartDetailsBtn')),
			dialogClass: "divItemDetails smallDialog",
			title: "Loading Item Details", 
			content: loadingContent, 
			onOpen: open
		});
	};
	
	const open = (el) => {
		const trigger = el;
		const itemID = trigger.id.replace("btnItemDetails_", "");
		prodName = trigger.parentNode.parentNode.querySelector(".productInfo").textContent;
		dialog = document.getElementById("popUpDialog");
		if(dialog){
			dialogHead = dialog.querySelector("h2");
			dialogContent = dialog.querySelector(".dialogContent");
		}
		//console.log(itemID);
		getDetails(itemID);
	};
	const getDetails = async (itemID) => {
		let responseHTML;
		try{
			const response = await fetch('/cart/itemdetails', { 
				method: 'POST', 
				body: JSON.stringify({ cartId: common.CartID, cartItemId: itemID }), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			});
			
			//if(!response.ok) throw new Error("Error processing item details request");
			responseHTML = await response.text();
		}catch(error){
			console.error(error);
			showError();
		}
		if(responseHTML.length) fillDialog(responseHTML);
		else showError();
	};
	const showError = () => {
		detailsDialog.Close();
		common.ShowMessage(messages.getItemDetailsError);
	};
	const fillDialog = (itemDetails) => {
		dialogHead.textContent = prodName;
		dialogContent.innerHTML = itemDetails;
		common.HideMessage();
	};
	
	return{
		Init: init
	};
};